// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V4H17V8H22V12.8365C21.2441 12.3092 20.3248 12 19.3333 12C17.846 12 16.5212 12.6958 15.6667 13.7796C14.8121 12.6958 13.4873 12 12 12C10.5127 12 9.18789 12.6958 8.33333 13.7796C7.47878 12.6958 6.15398 12 4.66667 12C3.67517 12 2.75589 12.3092 2 12.8365V8H7V4H6V2ZM11.0195 8H13.0215V6.00439H11.0195V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.3333 14C20.8061 14 22 15.1939 22 16.6667V22H16.6667V16.6667C16.6667 15.1939 17.8606 14 19.3333 14Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.6667 16.6667V22H9.33333V16.6667C9.33333 15.1939 10.5272 14 12 14C13.4728 14 14.6667 15.1939 14.6667 16.6667Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.33333 16.6667V22H2V16.6667C2 15.1939 3.19391 14 4.66667 14C6.13943 14 7.33333 15.1939 7.33333 16.6667Z"}}]};

const Castle6FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-6-filled',
    ref,
    icon: element,
  },
));

Castle6FilledIcon.displayName = 'Castle6FilledIcon';

export default Castle6FilledIcon;
